// Two things the review app's settings and plain CSS cannot do. Neither one
// moves or replaces the app's own elements.

// 1. Default order. The app lists reviews newest first and offers no setting
// for it here, so the list is switched once, when the widget appears, to the
// order below. Customers can still pick any other order from the dropdown.
const DEFAULT_SORT = "highest_rating";
// While the list reloads in the new order it is hidden (see the stylesheet);
// this is the longest that may last if the reload never reports back.
const SORT_TIMEOUT = 4000;

function applyDefaultSort(widget) {
  const select = widget.querySelector("select.jdgm-sort-dropdown");
  if (!select) return false;
  const available = Array.from(select.options).some(
    (option) => option.value === DEFAULT_SORT,
  );
  if (!available || select.value === DEFAULT_SORT) return true;

  const body = widget.querySelector(".jm-review-widget__body");
  const reveal = () => widget.classList.remove("aj-reviews-sorting");
  if (body) {
    widget.classList.add("aj-reviews-sorting");
    // The app marks the list while it loads; reveal it once that mark has
    // come and gone
    let loading = false;
    const watcher = new MutationObserver(() => {
      const active = body.classList.contains("jm-loading-overlay--active");
      if (active) loading = true;
      else if (loading) {
        watcher.disconnect();
        reveal();
      }
    });
    watcher.observe(body, { attributes: true, attributeFilter: ["class"] });
    setTimeout(() => {
      watcher.disconnect();
      reveal();
    }, SORT_TIMEOUT);
  }
  select.value = DEFAULT_SORT;
  select.dispatchEvent(new Event("change", { bubbles: true }));
  return true;
}

function watchForWidget() {
  const tryApply = () => {
    const widget = document.querySelector(".jdgm-review-widget.jdgm-widget-revamp");
    return !!widget && applyDefaultSort(widget);
  };
  if (tryApply()) return;
  const observer = new MutationObserver(() => {
    if (tryApply()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// 2. Photo viewer. The app crops every photo to a padded square. The stylesheet
// sizes the viewer around the photo instead, which needs the photo's shape:
// it is published here as --aj-photo-ratio (width / height) on the viewer.
function publishPhotoRatio(modal) {
  // Every photo of the gallery has a slide; the app marks the ones that are
  // waiting (is-idle) and the one sliding out (is-leaving)
  const image = modal.querySelector(
    ".jm-carousel__slide:not(.is-idle):not(.is-leaving) .jm-media__image",
  );
  if (!image) return;
  if (!image.dataset.ajRatioWatched) {
    image.dataset.ajRatioWatched = "1";
    image.addEventListener("load", () => publishPhotoRatio(modal));
  }
  if (!image.naturalWidth || !image.naturalHeight) return;
  const ratio = (image.naturalWidth / image.naturalHeight).toFixed(4);
  if (modal.style.getPropertyValue("--aj-photo-ratio") !== ratio)
    modal.style.setProperty("--aj-photo-ratio", ratio);
}

function watchForViewer() {
  const watched = new WeakSet();
  const attach = () => {
    // The viewer is added to the end of the page each time it opens
    document.querySelectorAll("body > .jdgm-modal.jdgm-widget-revamp").forEach((modal) => {
      if (watched.has(modal)) return;
      watched.add(modal);
      new MutationObserver(() => publishPhotoRatio(modal)).observe(modal, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "src"],
      });
      publishPhotoRatio(modal);
    });
  };
  new MutationObserver(attach).observe(document.body, { childList: true });
  attach();
}

watchForWidget();
watchForViewer();
